import { post, del } from '../request'

export const uploadFile = (params) => post('api/upload', params)
export const removeFile = (fileId) => del(`api/upload/files/${fileId}`)
